import { CardItemDetails } from "@faro-lotv/flat-ui";
import { SphereDashboardAPITypes } from "@stellar/api-logic";

/** Convert Stripe product data to card item details for display */
export function convertStripeProductToPackageCardItem(
  products: SphereDashboardAPITypes.StripeProduct[]
): CardItemDetails[] {
  return products.map((product) => ({
    title: product.name,
    subtitle: formatStripeDisplayPrice(product.price.price),
    badgeText: product.badge,
    value: product.id,
  }));
}

/**
 * Format Stripe price for display in full currency units.
 *
 * @param {string} priceInCents - The price comes from stripe in cents as a string.
 * @return {string} The formatted price in full currency unit(USD/EUR).
 */
export function formatStripeDisplayPrice(priceInCents: string): string {
  const priceInCurrencyUnit = parseFloat(priceInCents) / 100;
  return priceInCurrencyUnit.toLocaleString("en-US");
}